import { lazyLoad } from '~/src/shared/utils/loadable';

export const ParticipantWorkingTimeDetailPage = lazyLoad(
  () => import('./index'),
  (module) => module.ParticipantWorkingTimeDetail,
);
